import { useSelectedYouthParticipant, youthParticipantProfiles } from '../lib/youthParticipants'

export function YouthParticipantSwitcher({ compact = false }: { compact?: boolean }) {
  const { participant, selectParticipant } = useSelectedYouthParticipant()

  return (
    <section className={`${compact ? 'p-3' : 'p-4'} rounded-3xl border border-violet-200 bg-gradient-to-r from-violet-50 via-white to-cyan-50 shadow-card`}>
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="text-[10px] font-black uppercase tracking-[.14em] text-violet-600">Participant view</p>
          <h2 className="mt-1 text-sm font-black text-slate-900">Switch the child record you are viewing</h2>
        </div>
        <span className="rounded-full bg-white px-3 py-1.5 text-[10px] font-black text-violet-700">⇄ INTERCHANGE</span>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2" role="group" aria-label="Choose participant profile">
        {youthParticipantProfiles.map((profile) => {
          const active = participant.id === profile.id
          return <button
            key={profile.id}
            type="button"
            aria-pressed={active}
            onClick={() => selectParticipant(profile.id)}
            className={`flex items-center gap-2 rounded-2xl border-2 p-2.5 text-left transition active:scale-[.98] ${active ? 'border-violet-500 bg-white ring-2 ring-violet-100' : 'border-transparent bg-white/70'}`}
          >
            <img src={profile.photoUrl} alt="" className="h-11 w-11 shrink-0 rounded-xl object-cover" />
            <span className="min-w-0">
              <span className="block text-sm font-black text-slate-900">{profile.name}</span>
              <span className="block text-[10px] font-bold text-slate-500">Age {profile.age} · Lillian’s child</span>
            </span>
          </button>
        })}
      </div>
    </section>
  )
}

